import messageBox from "./messageBox"

export default {
  install(Vue) {
    Vue.use(messageBox)
  }
}
